module.exports = __webpack_public_path__ + "img/evolve-pic-4.85312594.jpg";